import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  sider: {
    border: `1px solid ${token.lightGrey.lightGrey1}`,
    overflow: 'hidden'
  }
}))
